import { defineMeta } from '@/registry/types';

export const settingsLayoutMeta = defineMeta({
  name: 'SettingsLayout',
  level: 'template',
  category: 'layout',
  classification: 'custom',
  description: 'Two-column settings page with section navigation and content area.',
  baseLibrary: 'custom',
  a2uiEquivalent: 'SettingsPage',
  importPath: '@/templates/SettingsLayout',
  requiredProps: ['sections', 'children'],
  optionalProps: ['title', 'activeId', 'onSelect'],
  supportedStates: ['default'],
  designTokens: ['spacing', 'radius'],
  accessibility: ['Section list items reflect selection; content updates accordingly.'],
  usageExamples: ['<SettingsLayout sections={s} activeId={id} onSelect={set}>...</SettingsLayout>'],
  antiPatterns: ['Do not use for non-settings content.'],
  llmSafe: true,
  whenToUse: ['Settings / preferences screens'],
  whenNotToUse: ['Tables (use TablePageLayout)'],
});

export default settingsLayoutMeta;
